import BaseMenuFetchComponent from 'frontend/components/base-menu-fetch';

export default class FooterMegaMenuComponent extends BaseMenuFetchComponent {}
